/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum SUBSCRIPTION_STATUS {
  activated = 'activated',
  pendingPayment = 'pendingPayment',
  waitingForPrinter = 'waitingForPrinter',
  pendingLocked = 'pendingLocked',
  pendingConfirmation = 'pendingConfirmation',
  canceled = 'canceled',
  locked = 'locked',
  locking = 'locking',
  pendingUnlocked = 'pendingUnlocked',
  renewed = 'renewed',
}

export enum SUBSCRIPTION_PLAN_TYPE {
  contract = 'yearly',
  monthToMonth = 'monthly',
}
